import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import EmailProps from '../../proptypes/email';
import UserProps from '../../proptypes/user';
import { isEmptyAddress } from '../../utils/address';
import { formatPhone } from '../../utils/phone';
import { MMMMYYYY } from '../../utils/time';
import AddressRow from './AddressRow';
import EmailRow from './EmailRow';

const UserSection = ({ email, hideLink, style, user }) => (
  <div className={style.right}>
    <div className={style.bigFirstName}>{user.fname}</div>
    <div className={style.bigLastName}>{user.lname}</div>
    <div className={style.memberSince}>
      Member Since&nbsp;
      {MMMMYYYY(user.date)}
    </div>
    <div>
      {!isEmptyAddress(user) && (
        <AddressRow address={user} prefillEdit={false} style={style} />
      )}
    </div>
    <div>
      {user.phone && (
        <p data-testid="overview-phone">{formatPhone(user.phone, false)}</p>
      )}
    </div>
    <div>{email && <EmailRow email={email} style={style} />}</div>
    <div className={style.profileLink}>
      {!hideLink && <Link to="/profile">Manage Full Profile</Link>}
    </div>
  </div>
);

UserSection.propTypes = {
  email: EmailProps,
  hideLink: PropTypes.bool,
  style: PropTypes.shape({
    bigFirstName: PropTypes.string,
    bigLastName: PropTypes.string,
    email: PropTypes.string,
    memberSince: PropTypes.string,
    right: PropTypes.string,
  }).isRequired,
  user: UserProps.isRequired,
};

UserSection.defaultProps = {
  hideLink: false,
};

export default memo(UserSection);
